import {Route} from 'react-router'
import LoggedRoute from '@freckle/school/ts/common/routers/logged-route'
import AssessmentReportHandler from '@freckle/school/ts/pages/assessment-report/components'
import AssessmentsHandler from '@freckle/school/ts/pages/assessments/components'

export default function RouterV2Assessments() {
  return (
    <>
      <Route
        path="/schools/:pathSchoolId/assessments"
        element={
          <LoggedRoute component={AssessmentsHandler} wrapperParams={{tabId: 'assessments'}} />
        }
      />
      <Route
        path="/assessments"
        element={
          <LoggedRoute component={AssessmentsHandler} wrapperParams={{tabId: 'assessments'}} />
        }
      />
      <Route
        path="/assessments/:pathSchoolId/:pathAssessmentId"
        element={
          <LoggedRoute component={AssessmentReportHandler} wrapperParams={{tabId: 'assessments'}} />
        }
      />
    </>
  )
}
